import classNames from "classnames";

export const SidebarDrawer = ({ showDrawer }: { showDrawer: boolean }) => {
  const clName = classNames("drawer", { shown: showDrawer });
  return <div className={clName} />;
};
